import { render, staticRenderFns } from "./PageFeed.pug?vue&type=template&id=e62627da&scoped=true&lang=pug&"
import script from "./PageFeed.vue?vue&type=script&lang=ts&"
export * from "./PageFeed.vue?vue&type=script&lang=ts&"
import style0 from "./PageFeed.vue?vue&type=style&index=0&id=e62627da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e62627da",
  null
  
)

export default component.exports